import { WidgetDefinition } from '../models/WidgetDefinition';

export const chartByIdentifierWidgetDefinition: WidgetDefinition = {
    baseType: 'chartByIdentifier',
    group: 'Charts',
    hasImage: true,
    highlights: ['Values aggregated over time as vertical bars or circles', 'You can convert all values on a common unit and optionally sort by ascending or descending order'],
    icon: 'fa-bar-chart',
    sortingOrder: 300,
    title: 'Chart by identifier',
    type: 'chartByIdentifier'
};